/* eslint-disable react/function-component-definition */
import { useIntl } from 'react-intl';
import { ITripsOverViewSummary } from '../interfaces';
import {
  CONSUMPTION_KILOGRAMS,
  CONSUMPTION_KW,
  CONSUMPTION_LITRES,
  DISTANCE,
  PARKING_DURATION,
  RIDE_COUNT,
  RIDE_DURATION,
} from '../constants';
import { TotalSummaryGraphic } from './TotalSummaryGraphic';

interface ITotalSummary {
  summariesData: ITripsOverViewSummary | undefined;
}

const TotalSummary = (props: ITotalSummary): JSX.Element => {
  const { formatMessage: f } = useIntl();

  const getSummariesData = (type: string) => {
    if (props.summariesData && props.summariesData.cells) {
      return Object.values(props.summariesData.cells).filter((i) => {
        return (
          i.name === type &&
          (i.value.public !== 0 || i.value.private !== 0 || i.value.anonymized !== 0)
        );
      });
    }
    return [];
  };

  const getAnonymizedValue = (value: any): number | undefined => {
    if (
      value &&
      value.anonymized !== null &&
      value.anonymized !== '[N/A]' &&
      value.anonymized !== 'GDPR'
    ) {
      return Number(value.anonymized);
    }
    return undefined;
  };

  return (
    <div className="b-summary-row">
      <div className="row no-gutters align-items-center">
        <span className="font-weight-bold mr-3">
          {f({ id: 'tripsoverview.totalsummary.title' })}
        </span>
        <span className="mr-4 d-inline-flex align-items-center">
          <span className="e-ride-summary-legend bg-dark-green" />{' '}
          {f({ id: 'tripsoverview.totalsummary.business.title' })}
        </span>
        <span className="mr-4 d-inline-flex align-items-center">
          <span className="e-ride-summary-legend private" />{' '}
          {f({ id: 'tripsoverview.totalsummary.private.title' })}
        </span>
        <span className="mr-4 d-inline-flex align-items-center">
          <span className="e-ride-summary-legend private-anonym" />{' '}
          {f({ id: 'tripsoverview.totalsummary.anonymized.title' })}
        </span>
      </div>
      <div className="mt-2 total-summary-grid">
        {getSummariesData(RIDE_COUNT).map((item) => (
          <div key={item.name}>
            <TotalSummaryGraphic
              name={item.name}
              title={f({ id: `tripsoverview.totalsummary.${item.name}` })}
              public={item.value ? Number(item.value.public) : 0}
              private={item.value ? Number(item.value.private) : 0}
              gdpr={getAnonymizedValue(item.value)}
              decimalComma
            />
          </div>
        ))}
        {getSummariesData(DISTANCE).map((item) => (
          <div key={item.name}>
            <TotalSummaryGraphic
              name={item.name}
              title={f({ id: `tripsoverview.totalsummary.${item.name}` })}
              public={item.value ? Number(item.value.public) : 0}
              private={item.value ? Number(item.value.private) : 0}
              gdpr={getAnonymizedValue(item.value)}
              decimalComma
            />
          </div>
        ))}
        {getSummariesData(RIDE_DURATION).map((item) => (
          <div key={item.name}>
            <TotalSummaryGraphic
              name={item.name}
              title={f({ id: `tripsoverview.totalsummary.${item.name}` })}
              public={item.value ? Number(item.value.public) : 0}
              private={item.value ? Number(item.value.private) : 0}
              gdpr={getAnonymizedValue(item.value)}
              decimalComma
            />
          </div>
        ))}
        {getSummariesData(PARKING_DURATION).map((item) => (
          <div key={item.name}>
            <TotalSummaryGraphic
              name={item.name}
              title={f({ id: `tripsoverview.totalsummary.${item.name}` })}
              public={item.value ? Number(item.value.public) : 0}
              private={item.value ? Number(item.value.private) : 0}
              gdpr={getAnonymizedValue(item.value)}
              decimalComma
            />
          </div>
        ))}
        {getSummariesData(CONSUMPTION_LITRES).map((item) => (
          <div key={item.name}>
            <TotalSummaryGraphic
              name={item.name}
              title={f({ id: `tripsoverview.totalsummary.fuelConsumption` })}
              public={item.value ? Number(item.value.public) : 0}
              private={item.value ? Number(item.value.private) : 0}
              gdpr={getAnonymizedValue(item.value)}
              decimalComma
            />
          </div>
        ))}
        {getSummariesData(CONSUMPTION_KW).map((item) => (
          <div key={item.name}>
            <TotalSummaryGraphic
              name={item.name}
              title={f({ id: `tripsoverview.totalsummary.fuelConsumption` })}
              public={item.value ? Number(item.value.public) : 0}
              private={item.value ? Number(item.value.private) : 0}
              gdpr={getAnonymizedValue(item.value)}
              decimalComma
            />
          </div>
        ))}
        {getSummariesData(CONSUMPTION_KILOGRAMS).map((item) => (
          <div key={item.name}>
            <TotalSummaryGraphic
              name={item.name}
              title={f({ id: `tripsoverview.totalsummary.fuelConsumption` })}
              public={item.value ? Number(item.value.public) : 0}
              private={item.value ? Number(item.value.private) : 0}
              gdpr={getAnonymizedValue(item.value)}
              decimalComma
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TotalSummary;
